import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { store } from '../store';
import { executeAttachment } from '@utils';

export const executeSvg = (name: string) => {
  let attachments = [];
  if (store) {
    attachments = store.getState().submissionEnvironment.attachments;
  }
  if (!_isEmpty(attachments)) {
    const image = executeAttachment(attachments, name);
    return _get(image, 'data.data');
  }
  return '';
};
